var UserService_1;
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { first, map } from 'rxjs';
import { ConstructorName } from '../../../decorators';
import * as i0 from "@angular/core";
import * as i1 from "../..";
let UserService = class UserService {
  static {
    UserService_1 = this;
  }
  api;
  monitoringService;
  url = 'geaid/v1/users';
  apiVersion;
  constructor(api, monitoringService) {
    this.api = api;
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', UserService_1), 'constructor');
  }
  getUser(userId, noMemberships = false) {
    const userResponseObs = this.api.get(this.url + `/${userId}?noMemberships=${noMemberships}`);
    return userResponseObs.pipe(map(user => ({
      id: user.id,
      customerUserType: user.customerUserType,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phoneNumber: user.phoneNumber,
      title: user.title,
      language: user.language,
      country: user.country,
      contactId: user.contactId,
      timeZone: user.timeZone ?? {
        offset: '',
        zoneId: ''
      },
      optInMFA: user.optInMFA,
      enforcedMFA: user.enforcedMFA,
      memberships: user.memberships.map(m => ({
        id: m.id.value,
        userId: user.id,
        inherited: m.inherited,
        customerNumber: m.organization.customerNumber,
        organizationId: m.organization.id,
        roleId: m.role.id,
        organizationName: m.organization.name,
        roleName: m.role.name,
        state: m.state
      }))
    })));
  }
  getActionRequired(userId) {
    return this.api.get(this.url + `/${userId}/actions`).pipe(first());
  }
  /**
   * Only gets a single non-inherited membership for the user.
   * @param userId
   */
  getTempUserMembership(userId) {
    return this.api.get(this.url + `/${userId}/memberships/paginated?noInheritedMemberships=true&page=0&pageSize=1`).pipe(first());
  }
  setApiVersion(apiVersion) {
    this.apiVersion = apiVersion ?? this.apiVersion;
    return this;
  }
  setUrl(url) {
    this.url = url ?? this.url;
    return this;
  }
  static ɵfac = function UserService_Factory(t) {
    return new (t || UserService)(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i1.MonitoringService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserService,
    factory: UserService.ɵfac,
    providedIn: 'root'
  });
};
UserService = UserService_1 = __decorate([ConstructorName('UserService')], UserService);
export { UserService };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ApiService
  }, {
    type: i1.MonitoringService
  }], null);
})();
